export const EXTRA_VERIFICATION_METHOD_IDS = ['email', 'sms', 'oktaVerify', 'googleAuth'];
